module.exports = __webpack_public_path__ + "nc_static/media/notvalidated.6ce03db3.svg";